import React from 'react'
import VerfiedCraftsman from '../blocks/craftsman/VerfiedCraftsman';
import Footer from '../component/footer/Footer';
import Services from '../blocks/craftsman/Services';
import HeaderTwo from '../component/header/HeaderTwo';
import JobHero from '../blocks/section/JobHero';
import { useThemeContext } from '../context/ThemeContext';
import { Box } from '@mui/joy';




const JobPost = () =>  {
  const { isSM, isMd } = useThemeContext()
  return (
    <>
      <Box
        sx={{
          width: isSM ? '100%' : isMd ? '100%' : '100%',
          padding: '0',
          backgroundColor: '#fff',
          boxSizing: 'border-box',

        }}
      >
        <HeaderTwo />
        <JobHero />
        <Services />
        <VerfiedCraftsman />
        <Footer />
      </Box>

    </>
  )
}

export default JobPost;